<ng-content></ng-content>
<ng-container *ngIf="displayArrowButton$ | async">
  <app-icon-button
    *ngIf="!(newCollapseButton$ | async)"
    data-cy="open-accordion-button"
    (click)="toggleClick()"
    [flip]="!(collapsed$ | async)"></app-icon-button>
  <button
    *ngIf="newCollapseButton$ | async"
    type="button"
    class="outline-pill-button icon-only small-icon"
    data-cy="open-accordion-button"
    (click)="toggleClick()">
    <mat-icon
      class="toggle-icon mat-icon size-20"
      svgIcon="chevron-down"
      [class.rotate]="!(collapsed$ | async)"></mat-icon>
  </button>
</ng-container>
